<template>
    <TopBar :navigationItems="navigationItems" appName="Team Story" :descriptionId="56" />
    <router-view />
</template>

<script setup lang="ts">
import { watch } from "vue";
import TopBar from "@/components/TopBar.vue";
import { useAuth } from "./composables/useAuth";
import { useTheme } from "./composables/useTheme";
import { useNavigation } from "./composables/useNavigation";

const { isAuthenticated } = useAuth();
const { initializeTheme } = useTheme();
const { navigationItems, loadNavigation } = useNavigation();

initializeTheme();

const stopWatcher = watch(
    isAuthenticated,
    async (authenticated) => {
        if (authenticated) {
            stopWatcher();
            await loadNavigation();
        }
    },
    { immediate: true }
);
</script>

<style lang="scss">
@use "assets/styles/common.scss";

.dx-toolbar-text-auto-hide .dx-button .dx-icon {
    width: 22px;
    height: 22px;
    font-size: 22px;
}
</style>
